import { useRef } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { agentPaymentsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UpdatePaymentMethodParams = {
	paymentMethodId: string;
	userId: string;
	active: string;
};

const useUpdateActiveAgentPaymentMethod = ({ tab, fetchData }) => {
	const queryClient = useQueryClient();
	const dispatch = useDispatch();
	const { page, sortBy } = fetchData;
	const idPaymentMethodUpdated = useRef<string | null>(null);

	const mutation = useMutation(
		(data: UpdatePaymentMethodParams) => {
			const { paymentMethodId, userId, active } = data;
			idPaymentMethodUpdated.current = paymentMethodId;
			return agentPaymentsService.editActivePaymentMethod({
				paymentMethodId,
				userId,
				active,
			});
		},
		{
			onMutate: async newValue => {
				return newValue;
			},
			onSuccess: (result, variables, newValue) => {
				queryClient.setQueryData(
					["getAgentPaymentMethods", tab, page, sortBy],
					(oldValues: any) => {
						return {
							count: oldValues?.count,
							items: oldValues?.items.map(oldValue =>
								oldValue.id === newValue?.paymentMethodId
									? {
											...oldValue,
											is_active: newValue?.active,
									  }
									: oldValue,
							),
						};
					},
				);
				dispatch(
					uiActions.showSuccessNotification({
						title: "Payment Method has been updated successfully",
					}),
				);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);

	const { mutate, isLoading } = mutation;
	return {
		mutate,
		isLoading,
		idPaymentMethodUpdated: idPaymentMethodUpdated.current,
	};
};

export default useUpdateActiveAgentPaymentMethod;
